import {Component, OnInit} from '@angular/core';
import {SharedModule} from "../../../shared/shared.module";
import {DataColumn} from "../../../models";
import {Router} from "@angular/router";
import {CandidatService} from "../../../services/candidat.service";
import {MatDialog} from "@angular/material/dialog";
import {CandidateDetailsComponent} from "./candidate-details-dialog/candidate-details.component";
import {AddressMenuComponent} from "../../../shared/components/address-menu/address-menu.component";
import {
  AgencyMoreDetailActionForCandidateComponent
} from "./agency-more-detail-action-for-candidate/agency-more-detail-action-for-candidate.component";
import {SvgIconComponent} from "angular-svg-icon";
import { CandidatComponent } from '../../candidat/candidat.component';
import { AddCandidateDialogComponent } from './add-candidate-dialog/add-candidate-dialog.component';

@Component({
  selector: 'app-agency-candidates',
  standalone: true,
  imports: [
    SharedModule,
    SvgIconComponent
  ],
  templateUrl: './agency-candidates.component.html',
  styleUrl: './agency-candidates.component.scss'
})
export class AgencyCandidatesComponent implements OnInit {

  size = 10;
  offset = 0;
  totalItems = 0;
  isLoading: boolean = false;
  searchKeyword: string = '';
  customColumns: DataColumn[] = [
    {
      header: 'Nom',
      fieldName: 'firstName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Prénom',
      fieldName: 'lastName',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Numéro de téléphone',
      fieldName: 'phone',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Adresse e-mail',
      fieldName: 'email',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Fonction',
      fieldName: 'function',
      dataType: 'string',
      col: 'col',
    },
    {
      header: 'Actions',
      unClickable: true,
      fieldName: '',
      dataType: 'component',
      component: AgencyMoreDetailActionForCandidateComponent,
    },
  ];
  etabList: any[] = [];
  candidateListFiltered: any[];
  totalItemsAfterFilter: number;

  constructor(private api: CandidatService,
              private dialog: MatDialog,
              private router: Router
  ) {
  }

  ngOnInit(): void {
    this.loadCandidates();
  }

  loadCandidates(): void {
    this.isLoading = true;
    this.api.getAgencyCandidatesWithPagination(this.offset, this.size, this.searchKeyword).subscribe({
      next: (response: any) => {
        this.candidateListFiltered = response.data.map((e: any) => {
          return {
            id: e.id,
            typePosteId: e.typePosteId,
            firstName: e.firstname || '',
            lastName: e.lastname || '',
            phone: e.phone,
            email: e.email,
            function: e.profession
          }
        });
        this.totalItems = response.total;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading candidates:', err);
        this.candidateListFiltered = [];
        this.totalItems = 0;
        this.isLoading = false;
      }
    });
  }

  handleRowClick(evt: any) {
    const candidatId = evt.id;
    const typePosteId = evt.typePosteId;
    this.router.navigate([`/agency/details-candidate/${candidatId}/${typePosteId}`])
  }

  pagination($event: any) {
    this.offset = $event.pageIndex ;
    this.loadCandidates();
  }

  searchItem(event: any) {
    this.offset = 0; // Reset to first page on search
    if (event) {
      this.searchKeyword = event.target.value.trim().toLowerCase();
    } else {
      this.searchKeyword = '';
    }
    this.loadCandidates();
  }
  openAddCandidatDialog() {
    this.dialog.open(AddCandidateDialogComponent, {
      width: '700px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result === 'refresh') {
        this.ngOnInit();   
      }
    });
  }

}
